import React, { useState, useEffect, useRef, useContext } from 'react'
import useForm from '../../formsFramework/core/useForm';
import { useLocation, useHistory, Link } from 'react-router-dom';
import api from '../../webApi';
import clsx from "clsx";
import moment from 'moment';
import './Login.css';
import loginbackground from '../../assets/images/loginbackground.png';
import usersignin from '../../assets/images/usersignin.png';
import usersms from '../../assets/images/usersms.png';
import { require, onlyNumbers, email, minLength, maxLength, length } from "../../formsFramework/validators";
import phonePrefixes from '../../assets/static-data/phonePrefixes';
import { FormContainer, FormField } from '../../formsFramework';
import { FormTextField } from "../../formsFramework/MaterialComponents";
import Divider from '@material-ui/core/Divider';
import { async } from 'react-app-polyfill/node_modules/regenerator-runtime';
//import ModSnakeBar from '../layout/ModSnakeBar/ModSnakeBar';
import ModModal from '../layout/ModModal/ModModal';
import { CircularProgress } from "@material-ui/core";
import { OutlinedInput, InputAdornment, FormControl, InputLabel, IconButton } from "@material-ui/core";
import Visibility from '@material-ui/icons/Visibility';
import VisibilityOff from '@material-ui/icons/VisibilityOff';
import { AppContext } from '../../AppContext';
import LoginHeader from '../layout/Header/LoginHeader';
import OTPField from '../../formsFramework/core/OTPField';
import { RadioButton } from 'primereact/radiobutton';
import { Button } from 'primereact/button';
import 'primereact/resources/themes/saga-blue/theme.css';
import 'primereact/resources/primereact.min.css';

const getIsMobile = () => window.innerWidth <= 800;
const SMSFromLogin = React.memo(props => {
    const location = useLocation();
    const [isMobile, setIsMobile] = useState(getIsMobile());
    const [isSMSview, setIsSMSview] = useState(false);
    const [showPassword, setShowPassword] = React.useState(false);
    const [isTextsms, setIsTextsms] = useState(true);
    //const [snackBarProps, setSnackBarProps] = useState({ display: false, variant: 'info', message: '', vertical: '', horizontal: '' });
    const [displayModal, setDisplayModal] = useState(false);
    //const [disableButReg,setDisableButReg] = useState(true);
    //const [loading, setLoading] = useState(false);
    const [config, setConfig] = useState({
        numInputs: 6,
        optValue: '',
        separator: '-',
        isTypeNumber: true,
        hasError: true,
        isDisabled: false,
    });
    const history = useHistory();
    const [userCode, setUserCode] = useState('');
    const { Dispatcher, displaySnackbarHandler, setLoading } = useContext(AppContext);

    let btnRef = useRef();
    let btnSMSRef = useRef();
    const sleep = async (time) => {
        return new Promise((resolve) => {
            setTimeout(() => {
                resolve()
            }, time)
        })
    }
    const isTest=false;
    useEffect(() => {
        /*if (isTest) {
            location.state = {
                UserKey: 'hq704767', isFirstEntry: true, loginDTO: {
                    MODsmsID: '1',
                    PhoneNumber: '0503404470'
                }
            };
        }*/
        if (location.state == undefined || location.state.Id == undefined || Dispatcher==null ||Dispatcher.rootUrl==null) {
            history.push("/");
        }
        setTimeout(() => {
           
            if ('OTPCredential' in window) {
                handleOtpRetrieval();
            }
        }, 5000);
        const onResize = () => {
            setIsMobile(getIsMobile);
        };
        window.addEventListener("resize", onResize);
        return () => {
            window.removeEventListener("resize", onResize);
        };
    }, []);
    const handleOtpRetrieval = () => {
        try {
            //alert('OTPCredential' in window)
            const ac = new AbortController();
            navigator.credentials.get({
                otp: { transport: ['sms'] },
                signal: ac.signal
            }).then(otp => {
                //alert(`got otp from client--->${otp}`);
                //alert(`got otp from client--->`, otp.code);
                console.log(`got otp from client--->`, otp.code);
                setUserCode(otp.code);
            }).catch(err => {
                console.console.error(err);
                //alert(`err: ${err}`);
            })

        }
        catch (e) {
            console.console.error(e);
            //alert(`handleOtpRetrieval:`, e.message);
        }
    }

    const displaySnackbar = (variant, message = '', vertical = '', horizontal = '') => {
        //setSnackBarProps({ display: true, variant: variant, message: message, vertical: vertical, horizontal: horizontal });
        displaySnackbarHandler(variant, message, vertical, horizontal);
        setLoading(false);
        if (btnRef.current) {
            btnRef.current.disabled = false;
        }
    }
    const handleOnSubmit = async (validatioState, form) => {
        if (location.state == undefined || location.state.Id == undefined || Dispatcher==null ||Dispatcher.rootUrl==null) {
            history.push("/");
        }
        if (btnRef.current) {
            btnRef.current.focus();
            btnRef.current.disabled = true;
        }
        try {
            if (userCode.length == 6) {
                setLoading(true);
                const loginDTO = {
                    userCode: userCode,
                    ID: location.state.Id,
                    Url: Dispatcher.PersonalAreaUrl,
                    RootUrl: Dispatcher.rootUrl
                }
                const res = await api.post(`ModLogin/SignInWithLoginSMSCode`, loginDTO).then(response => {
                    console.log(`response SignInWithSMSCode` , response);

                    if (response) {
                        if(response.status==200 && response.data=="{'status':'OK'}")
                        {
                            window.location.href = Dispatcher.PersonalAreaUrl;
                        }
                        console.log(response.data);
                        if (response && response.data == 2)//"TimeEnded"
                        {
                            displaySnackbar("error", "תם הזמן, יש לשלוח קוד חדש", 'top', 'center');
                            setUserCode('');
                        }
                        else
                            if (response && response.data &&
                                (response.data == 0 ||
                                    response.data == 3 ||
                                    response.data == 4))//"errors"
                            {
                                displaySnackbar("error", "ארעה שגיאה, אנא פני/ה למוקד התמיכה", 'top', 'center');
                                setUserCode('');
                            }
                            else
                                if (response && response.data == 1) {
                                    console.log('SignInWithSMSCode rseponse seccess ' + response);
                                    //window.location.href = "https://logintest.mod.gov.il/onlineservice/lobby.html";
                                    window.location.href = Dispatcher.PersonalAreaUrl;//Dispatcher.protocol + '://' + Dispatcher.rootUrl + Dispatcher.PersonalAreaUrl;
                                }
                    }
                    else {
                        displaySnackbar("error", "משתמש לא קיים במערכת, אנא פני/ה למוקד התמיכה", 'top', 'center');
                        setUserCode('');
                    }
                }).catch((error) => {
                    console.log(`error: `,error);
                    if (error.message.indexOf("302") > 0) {
                        //window.location.href = "https://logintest.mod.gov.il/onlineservice/lobby.html";//(`${process.env.PUBLIC_URL}\onlineservice\lobby.html`);
                        window.location.href = Dispatcher.PersonalAreaUrl;//Dispatcher.protocol + '://' + Dispatcher.rootUrl + Dispatcher.PersonalAreaUrl;
                    }
                    else {
                       
                        setUserCode('');
                        displaySnackbar("error", "בעיה בעת התחברות משתמש, אנא פנה/י למוקד התמיכה", 'top', 'center');
                    }
                    //window.location.href = Dispatcher.PersonalAreaUrl;

                });;
            }
            else {
                config.hasError = true;
            }
            //await sleep(8000);
            if (btnRef.current)
                btnRef.current.disabled = false;
            setLoading(false);
        }
        catch (error) {
            console.log(`error:`,error);
            if (error.message.indexOf("302") > 0) {
                //window.location.href = "https://logintest.mod.gov.il/onlineservice/lobby.html";//(`${process.env.PUBLIC_URL}\onlineservice\lobby.html`);
                window.location.href = Dispatcher.PersonalAreaUrl;//Dispatcher.protocol + '://' + Dispatcher.rootUrl + Dispatcher.PersonalAreaUrl;
            }
            else {
            displaySnackbar("error", "ארעה שגיאה, אנא פני/ה למוקד התמיכה", 'top', 'center');
            //btnRef.current.disabled = false;
            //setLoading(false);
            console.error(error);
            }
        }
    };
    const handleOnReSendSMSSubmit = async (e) => {
        setUserCode('');
        e.preventDefault();
        if (btnSMSRef.current)
            btnSMSRef.current.disabled = true;
        setLoading(true);

        const loginDTO = {
            IsVoiceMsg: !isTextsms,
            ID: location.state.Id,
            RootUrl: Dispatcher.rootUrl
        }
        const res = await api.post(`ModLogin/ReSentSMSCode`, loginDTO).then(response => {
            if (response && response.data.status) {
                location.state.Id = response.data.Data.smsRowId;
                let shortphone = response.data.Data.shortPhone;
                let message = 'נשלח קוד במסרון למספר XXX-XXX' + shortphone;
                displaySnackbar('info', message, 'top', 'center');
                //displaySnackbar('info', 'קוד נשלח במסרון', 'top', 'center');
                setTimeout(() => {           
                    if ('OTPCredential' in window) {
                        handleOtpRetrieval();
                    }
                }, 5000);

            }
            else {
                displaySnackbar("error", "ארעה תקלה, אנא פנ/י למוקד התמיכה", 'top', 'center');
            }

        }).catch((error) => {
            console.log(error);
            displaySnackbar("error", "בעיה בעת התחברות משתמש, אנא פנה/י למוקד התמיכה", 'top', 'center');
        });;
        btnSMSRef.current.disabled = false;
        setLoading(false);
    };
    const onUserCodeChange = (code) => {
        setUserCode(code);
        if (code.length == 6) {

            btnSMSRef.current.focus();
        }
    }
    const form = () => {
        return <FormContainer onSubmit={handleOnSubmit}
            defaultValues={{}}>
            {
                ({ values, submited, valid, validationState, reValidateField, resetField }) => {
                    return (
                        <>
                            {!isMobile &&
                                <>
                                    <div className='iconSignin iconSigninsms'>
                                        <img src={usersms} />
                                    </div>
                                </>
                            }
                            <div className="formContainer">
                                <fieldset>
                                    <legend>אימות מסרון</legend>
                                    <div className="formRow pt-5">
                                        {/* <FormField
                                            type="text"
                                            name="userCode"
                                            label="הזינ/י את 6 הספרות שקיבלת במסרון"
                                            id="Mod-usercode"
                                            Component={FormTextField}
                                            variant="standard"
                                            required
                                            validators={[require, length]}
                                            inputProps={{ maxLength: 6 }}
                                            minLength={6}
                                            className={clsx("formField")}
                                        /> */}
                                        <OTPField
                                            value={userCode}
                                            onChange={onUserCodeChange}
                                            numInputs={Number(config.numInputs)}
                                            onChangeRegex={/^([0-9]){0,}$/}
                                            autoFocus
                                            separator={<span>{config.separator}</span>}
                                            isTypeNumber={config.isTypeNumber}
                                            hasError={config.hasError}
                                            inputProps={{ className: 'otp-input', disabled: false }}
                                        />
                                    </div>
                                </fieldset>
                                <div className="submitWrap smsbtnWrapper">
                                    <button ref={btnSMSRef} type="submit" name="submit" className="submitBut smsbtns" >התחברות</button>
                                    {/* <button ref={btnRef} name="submit" type='link' className="forgotpasswordlink smsbtns" onClick={(e) => handleOnReSendSMSSubmit(e)}>שלחו קוד חדש לנייד שלי</button> */}
                                </div>
                                <section className='resentcode'>
                                    <h4>לא קיבלת קוד?</h4>
                                    <div className='flex align-items-center ml-2'>
                                        <RadioButton inputId='textsms' name='סמס רגיל' value={true} onChange={(e) => setIsTextsms(e.value)}
                                            checked={isTextsms === true}></RadioButton>
                                        <label htmlFor='textsms' className=''>סמס רגיל</label>
                                    </div>
                                    <div className='flex align-items-center ml-2'>
                                        <RadioButton inputId='voicesms' name='סמס קולי' value={false} onChange={(e) => setIsTextsms(e.value)}
                                            checked={isTextsms === false}></RadioButton>
                                        <label htmlFor='voicesms' className=''>סמס קולי</label>
                                    </div>
                                    <button ref={btnRef} name="resendssms" type='link' className="smsbtns mt-3" onClick={(e) => handleOnReSendSMSSubmit(e)}>שלחו שוב</button>
                                </section>
                                {/* <section className='flex flex-wrap gap-3 smsbtns'>
                                    <div className='flex align-items-center '>
                                        <RadioButton inputId='textsms' name='סמס רגיל' value={true} onChange={(e) => setIsTextsms(e.value)}
                                            checked={isTextsms === true}></RadioButton>
                                        <label htmlFor='textsms' className='ml-2'>סמס רגיל</label>
                                    </div>
                                    <div className='flex align-items-center'>
                                        <RadioButton inputId='voicesms' name='סמס קולי' value={false} onChange={(e) => setIsTextsms(e.value)}
                                            checked={isTextsms === false}></RadioButton>
                                        <label htmlFor='voicesms' className='ml-2'>סמס קולי</label>
                                    </div>
                                    <Button ref={btnRef} name="resendssms" type='button' className="smsbtns" onClick={(e) => handleOnReSendSMSSubmit(e)}>שלחו קוד חדש לנייד שלי</Button>
                                </section> */}
                            </div>
                        </>
                    )
                }
            }
        </FormContainer>
    }

    return (<div className='logincontainer sms oneform'>
        {form()}
    </div>

    )
});
export default SMSFromLogin;